import React from 'react'
import { GoInfo } from 'react-icons/go'
import { Form, Col, OverlayTrigger, Tooltip, Button } from 'react-bootstrap'


import './styles.css'

// componente input sem validacao
const ControlWithValidationInfo = ({ 
    type, 
    Col, 
    label, 
    name, 
    placeholder, 
    value, 
    error,
    handleChange,
    typeColumn="md", 
    valueColumn,
    readOnly=false,
    placement='top',
    tooltip,
    custom_style=''
    }) => {

    return (
        typeColumn === "md"
        ?
        <Col md>
            <Form.Group as={Col} controlId={name}>
                <Form.Label>
                    {label + "  "}
                    <OverlayTrigger
                        key={placement}
                        placement={placement}
                        overlay={
                            <Tooltip
                                className={custom_style}
                                style={{ whiteSpace: 'pre-line', textAlign: 'left' }}
                                id={`tooltip-${placement}`}>
                                {tooltip}
                            </Tooltip>
                        }
                        >
                        <button className='controlInfo-btn-tooltip'>
                            <GoInfo />
                        </button>
                    </OverlayTrigger>
                </Form.Label>
                <Form.Control
                    type={type}
                    name={name}
                    placeholder={placeholder}
                    value={value}
                    onChange={handleChange}
                    isInvalid={!!error}
                    readOnly={readOnly}
                />
                <Form.Control.Feedback type="invalid">
                    {error}
                </Form.Control.Feedback>
            </Form.Group>
        </Col>
        :
        <Col xs={valueColumn}>
            <Form.Group as={Col} controlId={name}>
                <Form.Label>
                    {label + "  "}
                    <OverlayTrigger
                        key={placement}
                        placement={placement}
                        overlay={
                            <Tooltip
                                className={custom_style}
                                style={{ whiteSpace: 'pre-line', textAlign: 'left' }}
                                id={`tooltip-${placement}`}>
                                {tooltip}
                            </Tooltip>
                        }
                        >
                        <button className='controlInfo-btn-tooltip'>
                            <GoInfo />
                        </button>
                    </OverlayTrigger>
                </Form.Label>
                <Form.Control
                    type={type}
                    name={name}
                    placeholder={placeholder}
                    value={value}
                    onChange={handleChange}
                    isInvalid={!!error}
                    readOnly={readOnly}
                />
                <Form.Control.Feedback type="invalid">
                    {error}
                </Form.Control.Feedback>
            </Form.Group>
        </Col>
    )
}

export default ControlWithValidationInfo;